import { FC } from "react";
import {IResolveFATServiceOrderFormSchema, FactoryAssessmentHeaderMap} from "./schema";
import lodash from "lodash";
import {classNames} from "utils";

const FactoryAssessmentSummary: FC<{ data: IResolveFATServiceOrderFormSchema["factoryAssessment"], values: IResolveFATServiceOrderFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div>
      <span className="text-xs font-light">Factory Assessment</span>
      <div className="grid grid-cols-3 gap-6 mt-2">
        <div className="col-span-3">
          <div className="mt-1 w-full ">
            <table className="min-w-full divide-y divide-gray-300 border border-gray-300 rounded-md">
              <thead className="bg-gray-50">
              <tr className="divide-x divide-gray-200">
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-2 text-left text-sm font-semibold text-gray-900"
                >
                  Criteria
                </th>
                <th
                  scope="col"
                  className="whitespace-nowrap px-2 py-2 text-sm font-semibold text-gray-900 w-[100px]"
                >
                  Status
                </th>
              </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
              {lodash.map(
                Object.keys(FactoryAssessmentHeaderMap),
                (header, idx) => {
                  const id = `${header}`;

                  return (
                    <tr key={idx} className="divide-x divide-gray-200">
                      <td className="p-0">
                        <input
                          key={idx}
                          type={"text"}
                          id={`index`}
                          name={`index`}
                          value={`${FactoryAssessmentHeaderMap[header as keyof  typeof FactoryAssessmentHeaderMap]}`}
                          placeholder={"eg. 1"}
                          disabled
                          className={classNames(
                            "focus:ring-primary-500 focus:border-primary-500 border-gray-200 bg-gray-50",
                            "block w-full text-ellipsis sm:text-sm placeholder:font-light placeholder:text-xs h-[38px] border-0 focus:border"
                          )}
                        />
                      </td>
                      <td className="p-0 whitespace-nowrap w-[100px] text-sm text-gray-500 dark:text-gray-400 text-left w-[200px] h-[38px]">
                        <input
                          key={idx}
                          type={"text"}
                          id={`${id}`}
                          name={`${id}`}
                          value={lodash.startCase(lodash.get(
                            data,
                            `${id}`,
                            ""
                          ))}
                          onChange={() => {}}
                          onBlur={() => {}}
                          disabled
                          className={classNames(
                            "outline-none block w-[300px] font-medium sm:text-sm placeholder:font-light placeholder:text-gray-700 placeholder:text-xs h-[38px]",
                            "focus:ring-primary-500 focus:border-primary-500 border-gray-200 border-0 focus:border",
                          )}
                        />
                      </td>
                    </tr>
                  );
                }
              )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FactoryAssessmentSummary;